module.exports = __webpack_public_path__ + "img/elmundo.21f62d2b.svg";